import { render } from "./deposittabset.vue?vue&type=template&id=15382d9c"
import script from "./deposittabset.vue?vue&type=script&lang=js"
export * from "./deposittabset.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__